module.exports = __webpack_public_path__ + "img/keymaker.cfaddc36.png";